import { render, staticRenderFns } from "./AjandaView.vue?vue&type=template&id=9ebb8d34"
import script from "./AjandaView.vue?vue&type=script&lang=ts"
export * from "./AjandaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports